import React from "react";
import { uniqueId } from "lodash";
import { Input, Label, FormGroup } from "reactstrap";
function SelectControl({ name, label, options, error, ...rest }) {
  const id = uniqueId(`${name}-`);
  const { optionsLabelKey = "name", optionsID = "id", ...inputProps } = rest;

  return (
    <FormGroup>
      <Label htmlFor={id}>{label}</Label>
      <Input {...inputProps} type="select" name={name} id={id} className="custom-select">
        {options.map((option) => (
          <option disabled={option.is_enabled === false} key={option[optionsID]} value={option[optionsID]}>
            {option[optionsLabelKey]}
          </option>
        ))}
      </Input>
    </FormGroup>
  );
}

export default SelectControl;
